(() => {
  const closeOtherMenus = (event) => {
    const current = event.target.closest('details');
    document.querySelectorAll('.ort-header details[open]').forEach((details) => {
      if (details !== current) details.removeAttribute('open');
    });
  };

  document.addEventListener('toggle', (event) => {
    if (event.target.matches?.('.ort-header details[open]')) closeOtherMenus(event);
  }, true);

  document.addEventListener('click', (event) => {
    const header = event.target.closest('.ort-header');
    const toggle = event.target.closest('[data-ort-mobile-toggle]');

    if (toggle && header) {
      const isOpen = header.dataset.mobileOpen === 'true';
      header.dataset.mobileOpen = String(!isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
      return;
    }

    document.querySelectorAll('.ort-header').forEach((item) => {
      if (!item.contains(event.target)) {
        item.dataset.mobileOpen = 'false';
        item.querySelector('[data-ort-mobile-toggle]')?.setAttribute('aria-expanded', 'false');
        item.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ort-header').forEach((header) => {
      header.dataset.mobileOpen = 'false';
      header.querySelector('[data-ort-mobile-toggle]')?.setAttribute('aria-expanded', 'false');
      header.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
    });
  });
})();

class OrtIngredientTabs extends HTMLElement {
  connectedCallback() {
    if (this.dataset.tabsReady === 'true') return;

    this.tabs = Array.from(this.querySelectorAll('[data-ingredient-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-ingredient-panel]'));
    if (!this.tabs.length || this.tabs.length !== this.panels.length) return;

    this.dataset.tabsReady = 'true';
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });
  }

  activate(index, moveFocus = false) {
    this.tabs.forEach((tab, tabIndex) => {
      const isActive = tabIndex === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
    });

    this.panels.forEach((panel, panelIndex) => {
      const isActive = panelIndex === index;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });

    if (moveFocus) this.tabs[index].focus();
  }

  onKeydown(event, index) {
    let nextIndex = index;
    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
    if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;
    if (nextIndex === index) return;

    event.preventDefault();
    this.activate(nextIndex, true);
  }
}

if (!customElements.get('ingredient-tabs')) {
  customElements.define('ingredient-tabs', OrtIngredientTabs);
}

document.addEventListener('shopify:block:select', (event) => {
  const tabs = event.target.closest('ingredient-tabs');
  const tab = event.target.querySelector('[data-ingredient-tab]');
  if (tabs && tab && tabs.tabs) tabs.activate(tabs.tabs.indexOf(tab));
});
